module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsSAAALEgHS3X78AAAAu0lEQVRIie1VwQmEMBCcHFeQJVjIPCzhOlA7uBIEpxBLSEd7n0TCYVQkCnc4sLDJZnfILMk6M8OZeJxa/XICScX1+jOJboIlPI8mShoAgGQjqQPQhlBPsovndt9AUiWpyoTbjL+PIBSeAEwJyTvYKg71YIGwT8Kpn+9BqjFJL6kOa/8tVdC8W6qzV6IBwIukjyQAagB13MshewOSzVriVuEZZjbbOI6WrkvY77/k67+KEkOHpIu+u4f+Fj6enYspzzIVQQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ic_scatter_grey.png
// module id = 332
// module chunks = 1